var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.634,
    height: 28.634,
    viewBox: "229.135 3523.599 28.634 28.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Instagram"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.72 3544.693h-8.535a2.473 2.473 0 0 1-2.47-2.47v-8.535a2.473 2.473 0 0 1 2.47-2.47h8.536a2.473 2.473 0 0 1 2.47 2.47v8.535a2.473 2.473 0 0 1-2.47 2.47Zm-4.267-11.175a4.442 4.442 0 0 0-4.437 4.437 4.441 4.441 0 0 0 4.437 4.436 4.44 4.44 0 0 0 4.436-4.436 4.441 4.441 0 0 0-4.436-4.437Zm4.579-1.18c-.58 0-1.05.47-1.05 1.049a1.051 1.051 0 0 0 2.1 0c0-.579-.471-1.05-1.05-1.05Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.453 3535.394a2.565 2.565 0 0 0-2.562 2.56 2.565 2.565 0 0 0 2.562 2.563 2.565 2.565 0 0 0 2.561-2.562 2.565 2.565 0 0 0-2.561-2.561Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.453 3552.233c-7.895 0-14.318-6.422-14.318-14.317 0-7.894 6.423-14.317 14.318-14.317 7.894 0 14.317 6.423 14.317 14.317 0 7.895-6.423 14.317-14.317 14.317Zm-4.267-22.89a4.35 4.35 0 0 0-4.345 4.344v8.535a4.35 4.35 0 0 0 4.345 4.346h8.534a4.35 4.35 0 0 0 4.345-4.346v-8.535a4.35 4.35 0 0 0-4.345-4.345h-8.534Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Shape"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon3);
export default __webpack_public_path__ + "static/media/socialIcon3.cd4fa8da92da378763d4c0b654232db5.svg";
export { ForwardRef as ReactComponent };